import { minimalInputTheme } from '@/app/theme';
import { getSignatureOptionMatchKey } from '@/features/unlayerUserSignatures/helpers';
import { Autocomplete, TextField } from '@mui/material';
import React from 'react';

export const UserEmailSignatureSelect = ({
	emailSignatures = [],
	disabled,
	onChange,
	minimal = false,
	value,
	loading = false,
}) => {

	return (
		<Autocomplete
			fullWidth
			disabled={disabled || loading}
			options={emailSignatures}
			value={value ?? null}
			isOptionEqualToValue={(option, val) =>
				getSignatureOptionMatchKey(option) === getSignatureOptionMatchKey(val)
			}
			getOptionLabel={(option) => option?.label ?? option?.name ?? ''}
			disableClearable
			onChange={(_, sig) => {
				if (sig !== null) {
					onChange?.(sig);
				}
			}}
			renderOption={(props, option) => (
				<li {...props} key={getSignatureOptionMatchKey(option)}>
					{option?.label ?? option?.name ?? ''}
				</li>
			)}
			renderInput={(params) => (
				<TextField
					{...params}
					variant={minimal ? 'standard' : 'outlined'}
					sx={(theme) => ({
						...(minimal && minimalInputTheme),
						'& .MuiInput-input': { color: theme.palette.primary.main },
					})}
					InputProps={{
						...params.InputProps,
						readOnly: true,
						style: { caretColor: 'transparent', cursor: 'pointer' },
					}}
				/>
			)}
			sx={{
				cursor: 'pointer',
				...(minimal && {
					...minimalInputTheme,
					'& .MuiInputBase-root': { backgroundColor: 'transparent' },
				}),
			}}
		/>
	);
};
